/*
 * @Author: your name
 * @Date: 2021-05-27 08:43:25
 * @LastEditTime: 2021-08-25 13:20:04
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\i18n\language\cn.js
 */
const cn = {
  message: {
    privacyPolicy: 'App隐私政策',
    firstTitle: '澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海。',
    secondTitle: '一、澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海。',
    thirdTitle: '二、澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海。',
    fourTitle: '三、澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海街道办南山区澳海。',
    serviceTerms: '服务条款',
    warehouseToday: '今日入库',
    stockToday: '今日出库',
    yesterdayEnterQuantity: '昨日入库',
    yesterdayOutQuantity: '昨日出库',
    deliveryInventory: '派件库存',
    retentionQuantity: '滞留件',
    sevenDaySendQuantity: '7日寄件单量',
    sevenDayPickQuantity: '7日揽收重量',
    stayBackQuantity: '待退回',
    ENTER_QUANTITY: '入库量',
    OUT_QUANTITY: '出库量',
    SEND_QUANTITY: '寄件单量',
    PICK_WEIGHT: '揽收重量',
    SEVEN: '近七天',
    THIS_MONTH: '本月',
    LAST_MONTH: '上月',
    THREE_MONTHS: '3个月',
    HALF_A_YEAR: '半年',
    piece: '件',

    message: '收款信息',
    bankName: '银行名称',
    KTbank: '开泰银行',
    bankAccounts: '银行账户',
    payeeName: '收款人',
    remark: '汇款备注',
    operatingProcedures: '操作流程',
    remark1: '1、通过推荐的银行汇款至我们的银行账号；',
    remark2: '2、登录APP，提交申请及上传凭证；',
    remark3: '3、工作人员将在2个工作日内完成审核',
    precautions: '注意事项',
    precautionsRemark1: '1、为了确保您审核成功，请您在打款时仔细核对收款信息填写是否正确',
    precautionsRemark2: '2、请您务必在填汇款备注中填写您的驿站编码，以便于我们核对您的汇款信息',
    fundsTotal: '资金总额',
    formula: '资金总额 = 预付款余额 + 经营收入',
    prepayment: '预付款',
    prepaymentRemarks1: '(1) 目前仅支持线下汇款充值',
    prepaymentRemarks2: '(2) 预付款可用于“打印面单”；未来，预付款可用于购买短信',
    prepaymentRemarks3: '(3) 预付款不可提现，不退换！！！',

    dayViewName: '每日视图',
    weightViewName: '重量视图',
    dayViewLeftTabName: '出库量',
    dayViewRightTabName: '派费',
    dayViewTableCol1Name: '日期',
    dayViewTableCol2Name: '出库量',
    dayViewTableCol3Name: '派费（฿）',
    dayViewTableNullData: '暂无数据',
    dayViewDataTotalLeft: '出库量（件）',
    dayViewDataTotalRight: '派费（฿）',
    weightViewPieDataTotal: '出库量',
    weightViewTableCol1Name: '公斤段',
    weightViewTableCol2Name: '占比',
    weightViewTableCol3Name: '出库量/派费（฿）',
    weightViewTableNullData: '暂无数据',
    weightViewDetailTableCol1Name: '运单号',
    weightViewDetailTableCol2Name: '计费重量（kg）',
    weightViewDetailTableCol3Name: '派费（฿）',
    weightViewDetailTableNullData: '暂无数据',
    weightViewDetailDataTotalLeft: '出库量（件）',
    weightViewDetailDataTotalRight: '派费（฿）',
    dataSelectTitle: '时间选择',
    dataSelectTimeConnectText: '至',
    dataSelectConfirmText: '确定',
    dataSelectCancelText: '取消',
    idcard1: '根据司法部门要求，邮寄快递需要实名认证实际寄件人，请转告寄件人需求，并请寄件人配合出示证件完成身份认证',
    idcard2: '上传证件',
    idcard3: '真实姓名',
    idcard4: '证件号码',
    idcard5: '请上传jpg,jpeg,png格式图片',
    idcard6: '上传图片大小不能超过10MB!',
    idcard7: '上传中',
    idcard8: '上传成功',
    idcard9: '请先上传证件',
    idcard10: '证件号码不能为空',
    idcard11: '姓名不能为空',
    idcard12: '认证成功',
    idcard13: '上传失败',
    idcard14: '请输入13位泰国身份证号',
    idcard15: '该页面已失效',
    idcard16: '证件类型',
    idcard17: '身份证',
    idcard18: '护照',
    idcard19: '护照姓名',
    idcard20: '护照号码',
    idcard21: '护照号码长度为1-30位',
    dateSelect: '日期选择',
    zhi: '至',
    detail: '详情',
    CODConfirmText: '确认交接',
    package: 'COD包裹数量',
    amount: 'COD金额',
    outbound: 'COD outbound details',
    confirmed: '已确认',
    unconfirmed: '待确认',
    outboundTime: '出库时间',
    courierSignature: '快递员签名',
    sign: '签名',
    clear: '清空',
    submit: '提交',
    waybillNo: '运单号',
    codRecord: '交接记录',
    Total: '合计',
    CreateHandover: '创建交接单'
  }
}
export default cn



// WEBPACK FOOTER //
// ./src/i18n/language/cn.js